import { render } from "./BalconyGardening.vue?vue&type=template&id=c090238a&scoped=true"
import script from "./BalconyGardening.vue?vue&type=script&lang=js"
export * from "./BalconyGardening.vue?vue&type=script&lang=js"

import "./BalconyGardening.vue?vue&type=style&index=0&id=c090238a&scoped=true&lang=scss"

import exportComponent from "D:\\web\\OpenServer\\domains\\lembergflowers\\lembergflowers\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c090238a"]])

export default __exports__